<template>
  <div>
    <b-row align-h="center">
      <b-col sm="12" md="10" lg="8" style="background: #fff" class="p-4">
        <router-link :to="getReturnLink()">Revenir à l'accueil</router-link>
        <h4 class="mt-4">
            Editeur de la plateforme
        </h4>
        <p>
            CHAMBRE NATIONALE DES COMMISSAIRES DE JUSTICE, établissement d’utilité publique institué par l’ordonnance n°2016-728 du 2 juin 2016 relative au statut de commissaire de justice
        </p>
        <p>
            44, rue de Douai<br>
            75009 Paris<br>
            01 49 70 12 90
        </p>

        <h4>
            Directeur de la publication
        </h4>
        <p>
            Patrick Sannino, Président
        </p>

        <h4>
            Hébergeur
        </h4>
        <p>
            DEEP BLOCK<br>
            Président : Christophe Lemee<br>
            77 boulevard Malesherbes - 75008 Paris<br>
            06 68 75 09 10 | c.lemee@deepblock.eu
        </p>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'LegalTerms',
  methods: {
    getReturnLink() {
      const via = this.$route.query.via;
      if (via === 'entreprise') {
        return { name: 'entrepriseLogin' };
      } else if (via === 'banque') {
        return { name: 'pmcaLogin' };
      } else {
        // Par défaut, rediriger vers la page d'accueil
        return { name: 'home' };
      }
    }
  }
}
</script>